"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var CustomerPurchase;
(function (CustomerPurchase) {
    CustomerPurchase["CustomerTvodPurchase"] = "CustomerTvodPurchase";
    CustomerPurchase["CustomerLinearPayPerViewPurchase"] = "CustomerLinearPayPerViewPurchase";
})(CustomerPurchase = exports.CustomerPurchase || (exports.CustomerPurchase = {}));
//# sourceMappingURL=CustomerPurchaseType.js.map